import { createFileRoute, redirect } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";

export const Route = createFileRoute("/app/admin/customers")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  beforeLoad: () => {
    throw redirect({ to: "/app/settings/customers" });
  },
});
